import { render } from "./WorkloadModal.vue?vue&type=template&id=12830f0a&scoped=true"
import script from "./WorkloadModal.vue?vue&type=script&lang=js"
export * from "./WorkloadModal.vue?vue&type=script&lang=js"

import "./WorkloadModal.vue?vue&type=style&index=0&id=12830f0a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12830f0a"]])

export default __exports__